











 












const node = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "meetingId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "SetTaskHighlightMutation_meeting",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Task",
      "kind": "LinkedField",
      "name": "task",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "meetingId",
              "variableName": "meetingId"
            }
          ],
          "kind": "ScalarField",
          "name": "isHighlighted",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SetTaskHighlightSuccess",
  "abstractKey": null
};

(node ).hash = "9bcbbf27196d26372b248bb0e63a2cdd";

export default node;
